<template>
  <div>
    <el-form
      ref="form"
      size="small"
      label-position="top"
      :rules="rules"
      :model="formData"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_batchSize') || '批量范围'"
            prop="batchMinSize"
          >
            <el-row :gutter="0">
              <el-col :span="11">
                <el-input-number
                  v-model="formData.batchMinSize"
                  :placeholder="
                    $l('form_placeholder_batchMinSize') ||
                      '请输入批量范围最小值'
                  "
                  :min="0"
                  :step="1"
                  :precision="0"
                  step-strictly
                  controls-position="right"
                  style="width: 100%"
                />
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-input-number
                  v-model="formData.batchMaxSize"
                  :placeholder="
                    $l('form_placeholder_batchMaxSize') ||
                      '请输入批量范围最大值'
                  "
                  :min="0"
                  :step="1"
                  :precision="0"
                  step-strictly
                  controls-position="right"
                  style="width: 100%"
                />
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_inspectionLevel') || '检验水平'"
            prop="inspectionLevel"
          >
            <el-input
              v-model.trim="formData.inspectionLevel"
              :placeholder="
                $l('form_placeholder_inspectionLevel') || '请输入检验水平'
              "
              clearable
              :maxlength="2"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_sampleSize') || '抽样数量'"
            prop="sampleSize"
          >
            <el-input-number
              v-model="formData.sampleSize"
              :placeholder="
                $l('form_placeholder_sampleSize') || '请输入抽样数量'
              "
              :min="0"
              :step="1"
              :precision="0"
              step-strictly
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_acceptanceNum') || '合格判定数'"
            prop="acceptanceNum"
          >
            <el-input-number
              v-model="formData.acceptanceNum"
              :placeholder="
                $l('form_placeholder_acceptanceNum') || '请输入合格判定数'
              "
              :min="0"
              :step="1"
              :precision="0"
              step-strictly
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    inspectionAqlCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        batchMinSize: [
          {
            required: true,
            message: this.$l('form_placeholder_batchSize') || '请输入批量范围',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const { batchMinSize, batchMaxSize } = this.formData

              if (!lodash.isNumber(batchMinSize)) {
                callback(
                  new Error(
                    this.$l('form_placeholder_batchMinSize') ||
                      '请输入批量范围最小值'
                  )
                )
                return
              }

              if (!lodash.isNumber(batchMaxSize)) {
                callback(
                  new Error(
                    this.$l('form_placeholder_batchMaxSize') ||
                      '请输入批量范围最大值'
                  )
                )
                return
              }

              if (!batchMinSize) {
                callback(
                  new Error(
                    this.$l('form_placeholder_batchMinSize_cannot_be_zero') ||
                      '批量范围最小值不能为零'
                  )
                )
                return
              }

              if (!batchMaxSize) {
                callback(
                  new Error(
                    this.$l('form_placeholder_batchMaxSize_cannot_be_zero') ||
                      '批量范围最大值不能为零'
                  )
                )
                return
              }

              if (batchMinSize > batchMaxSize) {
                callback(
                  new Error(
                    this.$l('tips_batchMinSize_must_less_than_batchMaxSize') ||
                      '批量范围最小值不能大于批量范围最大值'
                  )
                )
                return
              }

              callback()
            },
            trigger: 'blur',
          },
        ],
        inspectionLevel: [
          {
            required: true,
            message:
              this.$l('form_placeholder_inspectionLevel') || '请输入检验水平',
            trigger: 'blur',
          },
        ],
        sampleSize: [
          {
            required: true,
            message: this.$l('form_placeholder_sampleSize') || '请输入抽样数量',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!lodash.isNumber(value)) {
                callback(
                  new Error(
                    this.$l('form_placeholder_sampleSize') || '请输入抽样数量'
                  )
                )
                return
              }
              if (!value) {
                callback(
                  new Error(
                    this.$l('form_placeholder_sampleSize_cannot_be_zero') ||
                      '抽样数量不能为零'
                  )
                )
                return
              }

              callback()
            },
            trigger: 'blur',
          },
        ],
        acceptanceNum: [
          {
            required: true,
            message:
              this.$l('form_placeholder_acceptanceNum') || '请输入合格判定数',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const { sampleSize, acceptanceNum } = this.formData

              if (!lodash.isNumber(sampleSize)) {
                callback(
                  new Error(
                    this.$l('form_placeholder_sampleSize') || '请输入抽样数量'
                  )
                )
                return
              }

              if (!lodash.isNumber(acceptanceNum)) {
                callback(
                  new Error(
                    this.$l('form_placeholder_acceptanceNum') ||
                      '请输入合格判定数'
                  )
                )
                return
              }

              if (acceptanceNum > sampleSize) {
                callback(
                  new Error(
                    this.$l(
                      'form_placeholder_acceptanceNum_not_gt_sampleSize'
                    ) || '合格判定数不能大于抽样数量'
                  )
                )
                return
              }

              callback()
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.inspectionAqlCode) return
      const res = await this.$api
        .mrpInspectionAqlDetailApi({
          inspectionAqlCode: this.inspectionAqlCode,
        })
        .catch(() => null)

      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .mrpInspectionAqlSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
}
</style>
